
import React from "react";
import { ArrowRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { Ripple } from "./ripple-effect";

interface InteractiveHoverButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  text?: string;
  rippleEffect?: boolean;
}

const InteractiveHoverButton = React.forwardRef<
  HTMLButtonElement,
  InteractiveHoverButtonProps
>(({ text = "Button", className, rippleEffect = true, ...props }, ref) => {
  return (
    <button
      ref={ref}
      className={cn(
        "group relative cursor-pointer overflow-hidden rounded-full border bg-background p-2 text-center font-semibold",
        className,
      )}
      {...props}
    >
      <span className="inline-block transition-all duration-300 group-hover:opacity-0">
        {text}
      </span>
      <div className="absolute inset-0 z-10 flex h-full w-full items-center justify-center opacity-0 transition-all duration-300 group-hover:opacity-100">
        <div className="flex items-center justify-center gap-1.5 text-primary-foreground">
          <span>{text}</span>
          <ArrowRight size={20} />
        </div>
      </div>
      <div className="absolute left-[20%] top-[40%] h-2 w-2 scale-[1] rounded-lg bg-primary transition-all duration-300 group-hover:left-[0%] group-hover:top-[0%] group-hover:h-full group-hover:w-full group-hover:scale-[1.8] group-hover:bg-primary"></div>
      
      {/* Add ripple effect */}
      {rippleEffect && <Ripple color="rgba(255, 255, 255, 0.5)" />}
    </button>
  );
});

InteractiveHoverButton.displayName = "InteractiveHoverButton";

export { InteractiveHoverButton };
